import { APP_TYPES } from "../constants/AppConstants";
import { toSnakeCase } from "../utils/strUtils";
import { baeminLogoSvg, coupangLogoSvg, yogiyoLogoPng } from "./Assets";

export const renderAppIcon = function (type, byName = false) {
  if(byName) {
    switch (type) {
      case APP_TYPES.Beamin.name:
        return baeminLogoSvg;
      case APP_TYPES.Coupang.name:
        return coupangLogoSvg;
      default:
        return yogiyoLogoPng;
    }
  }
  else {
    switch (type) {
      case APP_TYPES.Beamin.type:
        return baeminLogoSvg;
      case APP_TYPES.Coupang.type:
        return coupangLogoSvg;
      default:
        return yogiyoLogoPng;
    }
  }
};

const AppLogo = ({ appName, size = 35, isByName }) => {
  const s = toSnakeCase(appName);
 
  return (
    <img
      className="rounded-full"
      src={renderAppIcon(s, isByName)}
      style={{ width: `${size}px`, height: `${size}px` }}
    ></img>
  );
};
export default AppLogo;
